import React from "react";
import { Outlet } from "react-router-dom";
// import { Outlet, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer"
// import { useAuth } from "../../context/AuthContext"
import "./GuestLayout.css"

const GuestLayout : React.FC = () => {
  // const navigate = useNavigate();
  // Accessing the user state from Redux
  // const { user, isAuthenticated } = useAuth()
  // If user is logged in, redirect to the home page
  // useEffect(() => {
  //   if (user && isAuthenticated) {
  //     navigate("/"); // Redirect to home if logged in
  //   }
  // }, [user, isAuthenticated, navigate]);
  return (
    <>
    <div className="layout">
        <Outlet />
      <Footer />
    </div>
    </>
    
      // <main className="layout-main">{children}</main>

  )
}

export default GuestLayout
